import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-three',
  templateUrl: './footer-three.component.html',
  styleUrls: ['./footer-three.component.css']
})
export class FooterThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
